import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from '../../assest/images/logo.png';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Style from '../Styles/DashboardStyle.module.css';
import Button from '../Styles/Button.module.css';
import { MdNotifications, MdHelpOutline, MdOutlineHome  } from "react-icons/md";
const DashboardTitle = (props)=>{
  const { user,token } = useSelector((state) => state.auth);
  console.log(user,"user")
    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };
      const NewmemberType = (!user?.lifeTimeMember || user?.lifeTimeMember === ""|| user?.lifeTimeMember==="null") 
  ? "Non Member" 
  : "Life Member";
    return( 
            <Row>
                <Col className={Style.flexHead}>
                    <h2 className={Style.DashboardTitle}>{props.title}</h2>
                    <div className={Style.memberBtn}>
                        {props.membertype ?( <Link to="/">
                        {NewmemberType==="Non Member"?
                            <p><img src={require("../../assest/images/non-member-img.png")} alt=""/> 
                            
                            
                             {NewmemberType}
                             
                             
                             </p>:
                              <p><img src={require("../../assest/images/member-life.png")} alt=""/> 
                            
                            
                             {NewmemberType}
                             
                             
                             </p>
                             }
                        </Link>):null
                        }
                        <Link to="/donate" className={Style.greenBtn}>DONATE</Link>
                    </div>
                </Col>
          </Row>
        )
    }
    
    export default DashboardTitle;